// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"175":"0565f2ceb0e1b149cd33","230":"10593727feb9d2ab4725","883":"138a485c20b54e500f87","932":"44c87f5cee7544e927ef","987":"6452467ac9ffdb713c20"}[chunkId] + ".js";
};